"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        /**
         * Framework class to add messages to the message bars and message center
         */
        var MessageManager = /** @class */ (function () {
            function MessageManager() {
                var _this = this;
                /**
                 * adds a handler for messages
                 */
                this.registerMessageHandler = function (messageHandler) {
                    if (!messageHandler) {
                        throw new Error("Argument null or undefined: messageHandler");
                    }
                    if (_this.messageHandlers[messageHandler.internalMessageHandlerName] === undefined) {
                        _this.messageHandlers[messageHandler.internalMessageHandlerName] = messageHandler;
                    }
                };
                /**
                 * removes a handler for messages.
                 */
                this.unregisterMessageHandler = function (messageHandler) {
                    if (!messageHandler) {
                        throw new Error("Argument null or undefined: messageHandler");
                    }
                    delete _this.messageHandlers[messageHandler.internalMessageHandlerName];
                };
                this.initialize = function () {
                    // add the default handler
                    _this.registerMessageHandler($dyn.messaging.messageHandlers.clientMessageHandler);
                };
                /**
                 * returns true if the framework added this message.
                 */
                this.isFrameworkMessage = function (messageId) {
                    if (messageId < 0) {
                        return true;
                    }
                    return false;
                };
                /**
                 * Routes the specified message to the proper target.
                 */
                this.add = function (message) {
                    message = _this.stripMessagePrefix(message);
                    if (!message.messageId) {
                        _this.nextId++;
                        // system generated or messages supplied with no id are - values
                        message.messageId = -_this.nextId;
                    }
                    _this.currentMessage = message;
                    _this.calculateMessageRouting(message, $dyn.messaging.MessageAction.AddMessage);
                    return message.messageId;
                };
                /**
                 * Routes the specified message to the proper target.
                 * This will process messages and prefix messages
                 */
                this.addMessages = function (msgList) {
                    var originalMsgCollection = $dyn.value(msgList);
                    var messagesToProcess = [];
                    var prefixMessagesToProcess = {};
                    // tslint:disable-next-line: prefer-for-of
                    for (var i = 0; i < originalMsgCollection.length; i++) {
                        if (!originalMsgCollection[i].messageId) {
                            _this.nextId++;
                            // system generated or messages supplied with no id are - values
                            originalMsgCollection[i].messageId = -_this.nextId;
                        }
                        if (_this.IsSetPrefixMessage(originalMsgCollection[i])) {
                            var prefixMessage = originalMsgCollection[i];
                            _this.processPrefixMessage(prefixMessage);
                            if (prefixMessage.rootPrefix) {
                                // add the new root
                                if (prefixMessagesToProcess[prefixMessage.rootPrefix] === undefined) {
                                    var prefixRootMessage = new $dyn.messaging.PrefixRootMessage();
                                    prefixRootMessage.messageId = prefixMessage.messageId;
                                    prefixRootMessage.formName = prefixMessage.formName;
                                    prefixRootMessage.formUniqueId = prefixMessage.formUniqueId;
                                    prefixRootMessage.rootPrefix = prefixMessage.rootPrefix;
                                    prefixRootMessage.text = prefixRootMessage.rootPrefix;
                                    prefixRootMessage.detailText = $dyn.label("Shell_PrefixRootMessage_DetailLinkText");
                                    prefixRootMessage.ActionMessageText = prefixRootMessage.detailText;
                                    prefixRootMessage.Value = $dyn.observable(prefixRootMessage.rootPrefix);
                                    prefixRootMessage.prefixSection.sectionTitle = prefixRootMessage.rootPrefix;
                                    prefixRootMessage.prefixParts = prefixRootMessage.prefixParts;
                                    prefixRootMessage.addPrefixMessage(prefixMessage);
                                    prefixMessagesToProcess[prefixMessage.rootPrefix] = prefixRootMessage;
                                    messagesToProcess.push(prefixRootMessage);
                                }
                                else {
                                    prefixMessagesToProcess[prefixMessage.rootPrefix].addPrefixMessage(prefixMessage);
                                }
                            }
                            else {
                                // Strip tab characters in message prefix and add it to the messages
                                var strippedMessage = _this.stripMessagePrefix(originalMsgCollection[i]);
                                if (strippedMessage) {
                                    messagesToProcess.push(strippedMessage);
                                }
                            }
                        }
                        else {
                            // Strip tab characters in message prefix
                            var strippedMessage = _this.stripMessagePrefix(originalMsgCollection[i]);
                            if (strippedMessage) {
                                messagesToProcess.push(strippedMessage);
                            }
                        }
                    }
                    if (messagesToProcess.length > 0) {
                        _this.calculateMessageRouting(messagesToProcess, $dyn.messaging.MessageAction.AddMessage);
                    }
                };
                /**
                 * Remove the specified message from the proper target.
                 */
                this.remove = function (messageId, formId) {
                    _this.currentMessageId = messageId;
                    _this.currentFormId = formId;
                    _this.calculateMessageRouting(messageId, $dyn.messaging.MessageAction.RemoveMessage);
                };
                /**
                 * clears the messages.
                 */
                this.clear = function () {
                    _this.calculateMessageRouting(null, $dyn.messaging.MessageAction.ClearMessages);
                };
                /**
                 * check if this is a prefix message.
                 */
                this.IsSetPrefixMessage = function (message) {
                    var isPrefix = false;
                    if (message && message.text) {
                        isPrefix = message.text.indexOf("\t") !== -1;
                        if (isPrefix) {
                            var count = (message.text.match(/\t/g) || []).length;
                            if (count > 20) {
                                message.text = message.text.replace(new RegExp("\t", "g"), " ");
                                isPrefix = false;
                            }
                        }
                    }
                    return isPrefix;
                };
                /**
                 * process the messages passing them to the handlers.
                 */
                this.calculateMessageRouting = function (message, actionType) {
                    if (actionType !== $dyn.messaging.MessageAction.ClearMessages) {
                        if (!message) {
                            throw new Error("Argument null or undefined: message");
                        }
                    }
                    if (!_this.messageHandlers) {
                        throw new Error("No MessageHandlers have been registered with the MessageManager");
                    }
                    // Call the handlers until one reports that handling should stop
                    $.each(_this.messageHandlers, function (key, value) {
                        switch (actionType) {
                            case $dyn.messaging.MessageAction.AddMessage:
                                if (Array.isArray(message)) {
                                    return value.AddMessages(message, _this);
                                }
                                else {
                                    return value.AddMessages([message], _this);
                                }
                            case $dyn.messaging.MessageAction.RemoveMessage:
                                return value.RemoveMessageHandlerMessage(_this.currentMessageId, _this);
                            case $dyn.messaging.MessageAction.ClearMessages:
                                return value.ClearMessages(_this);
                        }
                    });
                };
                /**
                 * Strips the prefix and tab characters from the message.
                 */
                this.stripMessagePrefix = function (message) {
                    if (message && message.text) {
                        var messageParts = message.text.split("\t");
                        message.text = messageParts[messageParts.length - 1];
                    }
                    return message;
                };
                /**
                 * process the prefix message.
                 */
                this.processPrefixMessage = function (message) {
                    if (message && message.text) {
                        message.prefixParts = message.text.split("\t");
                        message.prefixCount = message.prefixParts.length - 1;
                        message.rootPrefix = message.prefixParts[0];
                        message.text = message.prefixParts[message.prefixParts.length - 1];
                    }
                };
                this.nextId = 1;
                this.messageHandlers = {};
                this.initialize();
            }
            return MessageManager;
        }());
        messaging.MessageManager = MessageManager;
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
    $dyn.messageManager = new $dyn.messaging.MessageManager();
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageManager.js.map
